export default "__VITE_ASSET__CM6nhGAd__"